module.exports = __webpack_public_path__ + "img/service.dfd7d54f.png";